// Calculates the VAT value based on the VAT persentage
export const getVatValue = (payment?: number, percentage?: number) => {
  if (payment && percentage) {
    const vatValue = (payment / (100 + percentage)) * percentage;
    const vatValueRounded = Math.round((vatValue + Number.EPSILON) * 100) / 100;

    return vatValueRounded;
  }
};
